import { render, staticRenderFns } from "./safetyOrgChartTemp.vue?vue&type=template&id=708a98aa"
import script from "./safetyOrgChartTemp.vue?vue&type=script&lang=js"
export * from "./safetyOrgChartTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708a98aa')) {
      api.createRecord('708a98aa', component.options)
    } else {
      api.reload('708a98aa', component.options)
    }
    module.hot.accept("./safetyOrgChartTemp.vue?vue&type=template&id=708a98aa", function () {
      api.rerender('708a98aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/org/safetyOrgChartTemp.vue"
export default component.exports